export const loadFont = async (font, callback) => {}

export default {}
